/* eslint-disable no-console */
/**
 * Language mutations
 *
 * JavaScript
 *
 * @category    src\assets
 * @package     actions\lang-mutations.js
 * @author      Jesús Armando Talavera Morán.
 * @copyright   2019-2050 laredoloads.com
 * @link        http://laredoloads.com
 */

import * as spanish from '../lang/es.js'
import * as english from '../lang/en.js'

export const mutations = {
  /**
   * Mutates language state
   * @param {Object, object} state & payload - sort option
   */
  langState (state, payload) {
    switch (payload) {
      case 'ES':
        state.language = spanish
        state.short = 'ES'
        state.id = 0
        localStorage.setItem('lang', 'ES');
        break
      case 'EN':
        state.language = english
        state.short = 'EN'
        state.id = 1
        localStorage.setItem('lang', 'EN');
        break
    }
  }
}
  